// zepto custom code
function shopifyFormatCurrency(cents) {
    const placeholderRegex = /{{\s*(\w+)\s*}}/;
  
    function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
      if (isNaN(number) || number == null) {
        return "0";
      }
  
      const numString = (number / 100.0).toFixed(precision);
      const parts = numString.split(".");
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      const cents = parts[1] ? decimal + parts[1] : "";
      return dollars + cents;
    }
    
    const formatString = pplr_money_formate
    if(!formatString){
      return cents / 100
    }

    return formatString.replace(placeholderRegex, (match, placeholder) => {
      switch (placeholder) {
        case "amount":
          return formatWithDelimiters(cents, 2);
        case "amount_no_decimals":
          return formatWithDelimiters(cents, 0);
        case "amount_with_comma_separator":
          return formatWithDelimiters(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator":
          return formatWithDelimiters(cents, 0, ".", ",");
        case "amount_with_apostrophe_separator":
          return formatWithDelimiters(cents, 2, "'", ".");
        case "amount_no_decimals_with_space_separator":
          return formatWithDelimiters(cents, 0, " ");
        case "amount_with_space_separator":
          return formatWithDelimiters(cents, 2, " ", ",");
        case "amount_with_period_and_space_separator":
          return formatWithDelimiters(cents, 2, " ", ".");
        default:
          return match;
      }
    });
}
async function setCartItemPrice() {
    var setCartItemPriceInterval;
    setCartItemPriceInterval = setInterval(async () => {
        if(typeof pplr_money_formate === "undefined"){
            return
        }
        clearInterval(setCartItemPriceInterval)
        const url = "/cart.json";
        try {
            const response = await fetch(url);
            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }

            const json = await response.json();
            const items = json.items
            
            let totalPrice = 0;
            if (items && items.length > 0) {
                const root = document.querySelector("#upCart")
                root.querySelectorAll(".upcart-product-item").forEach((element, idx) => {

                    const item = items[idx]
                    let price = parseInt(item?.final_price)
                    const properties = item?.properties
                    if(properties?._pplr_addprice){
                        price += parseInt(properties?._pplr_addprice)
                    }
                    totalPrice += price;
                    console.log(shopifyFormatCurrency(price))
                    element.querySelector(".upcart-item-price").textContent = shopifyFormatCurrency(price)
                    
                })
                root.querySelector(".upcart-checkout-button").textContent = `Checkout • ${shopifyFormatCurrency(totalPrice)}`
            }
            console.log(json);
        } catch (error) {
            console.error(error.message);
        }
    }, 100);
}
setCartItemPrice()
window.addEventListener('pplrAddToCartCompleted' , function(e) {
    setCartItemPrice()
})
// zepto custom code